import { useEffect } from 'react';
import { resolveAiHubApiOrigin } from '@/configs/aiHubApiOrigin';

const DEFAULT_LEGACY_EMBED_API = 'https://labs-api.toppion.com.vn';

function legacyEmbedApiBase(): string {
  const override = process.env.NEXT_PUBLIC_AI_LEGACY_EMBED_API?.trim();
  if (override) return override.replace(/\/$/, '');
  return resolveAiHubApiOrigin() || DEFAULT_LEGACY_EMBED_API;
}

const SCRIPT_ID = 'toppion-ai-embed-script';
const ROOT_ID = 'tpn-root';
const STYLE_ID = 'tpn-embed-style';

type ToppionWindow = Window & { __TOPPION_EMBED__?: boolean };

function cleanupEmbed() {
  document.getElementById(SCRIPT_ID)?.remove();
  document.getElementById(ROOT_ID)?.remove();
  document.getElementById(STYLE_ID)?.remove();
  delete (window as ToppionWindow).__TOPPION_EMBED__;
}

function injectEmbed() {
  if (document.getElementById(SCRIPT_ID)) return;

  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.src = '/toppion-embed.js';
  script.async = true;
  script.setAttribute('data-api', legacyEmbedApiBase());
  script.setAttribute('data-title', 'Trợ lý BSC');
  script.setAttribute('data-theme', 'light');
  script.setAttribute('data-color', '#0c68e9');
  script.removeAttribute('data-intent');
  document.body.appendChild(script);
}

/** Nhánh legacy: cùng gate Active AI, UI từ toppion-embed.js (FAB + panel script). */
export function ToppionAILegacyEmbedRuntime({ active }: { active: boolean }) {
  useEffect(() => {
    if (!active) {
      cleanupEmbed();
      return;
    }
    injectEmbed();
    return () => cleanupEmbed();
  }, [active]);

  return null;
}
